import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider } from '@mui/material';
import AcknowledgmentSection from './AcknowledgementSection';
import { Trans } from 'react-i18next';

interface Props {
  onClose: () => void;
  open: boolean;
}

const AcknowledgmentDialog = ({ open, onClose }: Props) => (
  <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
    <DialogTitle align="center">
      <Trans i18nKey="acknowledgementDialog.menu.acknowledgments">Acknowledgments</Trans>
    </DialogTitle>
    <Divider />
    <DialogContent sx={{ px: { xs: 2, sm: 3 }, py: 3, maxHeight: '65vh' }}>
      <AcknowledgmentSection />
    </DialogContent>
    <Divider />
    <DialogActions sx={{ px: 3, py: 1.5 }}>
      <Button variant="contained" onClick={onClose}>
        <Trans i18nKey="acknowledgementDialog.button.close">Close</Trans>
      </Button>
    </DialogActions>
  </Dialog>
);

export default AcknowledgmentDialog;
